import { render } from "./InputTypeSelect.vue?vue&type=template&id=625024a5"
import script from "./InputTypeSelect.vue?vue&type=script&lang=js"
export * from "./InputTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__